export const LOCALES = ["en", "pt-BR"] as const;
export type Locale = (typeof LOCALES)[number];

export const LOCALE_STORAGE_KEY = "strust.explorer.locale";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}

/** Saved choice, else the browser language (pt* becomes pt-BR), else English (the source catalog). */
export function resolveInitialLocale(): Locale {
  const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  if (isLocale(saved)) return saved;
  return navigator.language.toLowerCase().startsWith("pt") ? "pt-BR" : "en";
}
